import { render } from "./EmptyStatePage.vue?vue&type=template&id=469c4f8b&scoped=true"
import script from "./EmptyStatePage.vue?vue&type=script&lang=js"
export * from "./EmptyStatePage.vue?vue&type=script&lang=js"

import "./EmptyStatePage.vue?vue&type=style&index=0&id=469c4f8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469c4f8b"]])

export default __exports__